import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { getServiceMeta } from "../lib/serviceIcons";

export default function Pricing() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data.services)); }, []);

  return (
    <div className="container-pad mx-auto max-w-[1200px] py-16 md:py-24" data-testid="pricing-page">
      <span className="label-eyebrow">Pricing</span>
      <h1 className="mt-3 text-4xl sm:text-5xl font-display font-medium tracking-tighter text-[#121C17]">Honest pricing. No surprises.</h1>
      <p className="mt-4 text-[#5C6661] max-w-2xl">All charges are inclusive of professional fees. Government fees, where applicable, are billed at actuals and shared upfront on chat.</p>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {services.map((s) => {
          const { icon: Icon, accent, bgSolid } = getServiceMeta(s);
          return (
            <div key={s.id} className="bento-card p-7" data-testid={`pricing-card-${s.id}`}>
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-2xl grid place-items-center" style={{ background: bgSolid, color: accent }}>
                  <Icon size={22} />
                </div>
                <span className="label-eyebrow text-[10px]">{s.category}</span>
              </div>
              <h3 className="mt-4 text-xl font-display font-medium text-[#121C17]">{s.name}</h3>
              <div className="mt-3 text-3xl font-display font-medium" style={{ color: accent }}>{s.price_label}</div>
              <p className="mt-3 text-sm text-[#5C6661]">{s.tagline}</p>
              <Link to={`/apply/${s.id}`} className="mt-6 inline-flex items-center gap-1 text-sm font-medium hover:underline" style={{ color: accent }} data-testid={`pricing-cta-${s.id}`}>Start now →</Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
